module.exports = __webpack_public_path__ + "img/hr-tank-base-shadow-3.b9b2cc3b.png";